import { render } from "./staff.vue?vue&type=template&id=84cf39da"
const script = {}

import "./staff.vue?vue&type=style&index=0&id=84cf39da&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__